import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { from } from 'rxjs';
import { max } from 'rxjs/operators';
import { RouteStateService } from './../../../../core/services/route-state.service';
import { MoveOrderService } from './../../services/move-order.service';

@Component({
  selector: 'laas-do-detail',
  templateUrl: './do-detail.component.html',
  styleUrls: ['./do-detail.component.scss'],
})
export class DoDetailComponent implements OnInit, AfterViewInit {
  DODetail: any;
  flowStatuses: MenuItem[];
  columns: any[];
  selectedCols: any[];
  moveOrders: any[];
  detailCols: any[];
  moveOrderItems: any[];
  currentStatusIdx: number;
  shippmentTracks: any[];
  MOStatusOptions: any[];

  constructor(
    private routeStateService: RouteStateService,
    private MOService: MoveOrderService,
    private datePipe: DatePipe
  ) {
    this.flowStatuses = [
      { label: '　' },
      { label: '派工' },
      { label: '揀貨' },
      { label: '箱到齊' },
      { label: '出倉' },
      { label: '到貨' },
    ];
    this.columns = [
      { field: 'facility', header: '倉別' },
      { field: 'doNo', header: '出貨單號' },
      { field: 'pdNo', header: '移轉工單' },
      { field: 'moStatus', header: '狀態' },
      { field: 'soldToName', header: '客戶' },
      { field: 'customerNotes', header: '備註' },
    ];
    this.selectedCols = this.columns;
    this.moveOrders = [];
    this.detailCols = [
      { field: 'letterHeadOrgName', header: '公司別' },
      { field: 'deliveryType', header: '訂單類型(出口/國內)' },
      { field: 'pdNo', header: '移轉工單' },
      { field: 'sku', header: 'ERP料號' },
      { field: 'altSku', header: '客戶料號' },
      { field: 'originalQty', header: '數量' },
    ];
    this.moveOrderItems = [];
    this.currentStatusIdx = -1;
    this.shippmentTracks = [];

    this.MOStatusOptions = [
      { label: '已通知', value: '0' },
      { label: '已排單', value: '1' },
      { label: '已配貨', value: '2' },
      { label: '揀貨中', value: '3' },
      { label: '已揀貨', value: '4' },
      { label: '已合流', value: '5' },
      { label: '已貼標', value: '6' },
      { label: '已QC', value: '7' },
      { label: '箱到齊', value: '8' },
      { label: '已開票', value: 'I' },
      { label: '待自動Booking', value: 'AT' },
      { label: '待手動Booking', value: 'MA' },
      { label: '已Booking', value: 'B' },
      { label: '已上車', value: 'J' },
      { label: '已出倉', value: 'K' },
      { label: '已到港', value: 'P' },
      { label: '已到貨', value: 'O' },
    ];
  }

  @Input() get selectedColumns(): any[] {
    return this.selectedCols;
  }

  set selectedColumns(cols: any[]) {
    this.selectedCols = this.columns.filter((col) => cols.includes(col));
  }

  ngOnInit(): void {
    this.DODetail = this.routeStateService.getCurrent().data;
    this.MOService.getMoveOrdersByDONo(this.DODetail.doNo).subscribe({
      next: (result) => {
        this.moveOrders = result;
      },
    });
  }

  ngAfterViewInit(): void {
    //get Estimated Date
    this.MOService.getEstimatedDate(this.DODetail.doNo).subscribe({
      next: (result) => {
        var steps = document.querySelector('.p-steps');
        var lis = steps?.querySelectorAll('li');
        var tmpIndex = 0;
        lis?.forEach((li) => {
          var date = "-";

          switch (tmpIndex) {
            case 0:
              date = "預估";
              break;
            case 1:
              date = this.datePipe.transform(
                result.estimatedAllocateDt,
                'yyyy/MM/dd HH:mm:ss'
              ) ?? "-";
              break;
            case 2:
              break;
            case 3:
              break;
            case 4:
              date = this.datePipe.transform(
                result.estimatedLeaveWarehouseDt,
                'yyyy/MM/dd HH:mm:ss'
              ) ?? "-";
              break;
            case 5:
              date = this.datePipe.transform(
                result.estimatedArrivalDt,
                'yyyy/MM/dd HH:mm:ss'
              ) ?? "-";
              if(date != "-"){
                date = `<a onclick="window.open('${result.tmsUrl}')" href="javascript: void(0);" >${date}</a>`
              }
              break;
          }

          var spanNo = li.querySelector('span.p-steps-number') as any;
          if(spanNo != null){
            spanNo.innerText = tmpIndex == 0 ? "" : tmpIndex.toString();
          }
          if(tmpIndex == 0){
            spanNo?.setAttribute('style', 'border:0px solid #fff;background-color:#F8F9FA;');
          }

          var spanTitle = li.querySelector('span.p-steps-title');

          var div = document.createElement('div');
          div.innerHTML = date == null ? '' : date;
          spanTitle?.appendChild(div);
          spanTitle?.setAttribute('style', 'text-align:center;');

          if(tmpIndex == 0){
            var div = document.createElement('div');
            div.innerText = "實際";
            spanTitle?.appendChild(div);
          }

          tmpIndex++;
        });

        this.getRealDate();
      },
      complete: () => {

      },
    });
  }

  private getRealDate(): void {
    this.MOService.getShippmentTracks(this.DODetail.doNo).subscribe({
      next: (result) => {
        this.shippmentTracks = result;
        this.shippmentTracks.forEach((track) => {
          switch (track.activity) {
            case 'Order Processed':
              track.status = 1;
              break;
            case 'Picked Up':
              track.status = 2;
              break;
            case 'Packed Up':
              track.status = 3;
              break;
            case 'Out for Delivery':
              track.status = 4;
              break;
            case 'Delivered':
              track.status = 5;
              break;
          }
        });
        //max status
        let max_status_observable = from(this.shippmentTracks).pipe(
          max((a, b) => a.status - b.status)
        );
        max_status_observable.subscribe((x) => {
          var steps = document.querySelector('.p-steps');
          var lis = steps?.querySelectorAll('li');
          var tmpIndex = 0;
          lis?.forEach((li) => {
            li.classList.add('p-disabled');
            li.classList.remove('p-highlight');
            if (tmpIndex <= x.status) {
              li.classList.remove('p-disabled');
              li.classList.add('p-highlight');

              var shippmentTrack = this.shippmentTracks.filter((track) => {
                return track.status === tmpIndex;
              });

              if (shippmentTrack.length > 0) {
                var date = this.datePipe.transform(
                  shippmentTrack[0].processDt,
                  'yyyy/MM/dd HH:mm:ss'
                );
                var spanTitle = li.querySelector('span.p-steps-title');

                var div = document.createElement('div');
                div.innerText = date == null ? '' : date;
                spanTitle?.appendChild(div);
                spanTitle?.setAttribute('style', 'text-align:center;');
              }

              tmpIndex++;
            }
          });
        });
      },
    });
  }

  rowToggleBtnClick(event: any, rowData: any, expanded: boolean): void {
    if (expanded === false) {
      this.MOService.getMoveOrderItemsByPDNo(rowData.pdNo).subscribe({
        next: (result) => {
          rowData.moveOrderItems = result;
        },
      });
    }
  }
}
